module.exports = __webpack_public_path__ + "img/home-case-06.9ae4ba31.png";